import React from 'react';

function PulseItGroupFooter({ variant }) {
    const onDark = variant === 'dark';
    const color = onDark ? 'rgba(255,255,255,.65)' : '#64748b';
    const link = onDark ? 'rgba(255,255,255,.85)' : '#0f172a';

    return (
        <footer className="text-center px-3 py-3" style={{ color, fontSize: 12, lineHeight: 1.6 }}>
            <div>Licensed to Pulse IT Group</div>
            <div>
                Pulse IT Group
                {' | '}
                <a href="https://pulseitgroup.com/" target="_blank" rel="noopener noreferrer" style={{ color: link, textDecoration: 'none' }}>
                    https://pulseitgroup.com/
                </a>
                {' | '}
                <a href="mailto:info@pulseitgroup.com" style={{ color: link, textDecoration: 'none' }}>
                    info@pulseitgroup.com
                </a>
            </div>
        </footer>
    );
}

export default PulseItGroupFooter;
